import React, { Component, Fragment } from "react";
import { LoggedUserContext } from "../LoggedUserContext";
import { acquireToken } from "../adalConfig";

import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Grid,
} from "@material-ui/core/";
import Axios from "axios";

import { Alert } from "reactstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Spinner } from "./Spinner";

const MySwal = withReactContent(Swal);

export default class DoNotDisturbAddMultipleForm extends Component {
  state = {
    openMultiple: false,
    loadingFile: false,
    emailParam: "",
    email: "",
    js: {
      excludedEmail: {
        excludedEmailId: "",
        excludedEmailStatus: true,
        excludedEmailCreateDate: new Date(),
        excludedEmailLastUpdateDate: new Date(),
        excludedEmailUserModifiedId: this.context.userId,
      },
      user: this.context,
    },
    
    validPeopleList: 0,
    invalidEmailsList: 0,
    doNotDisturbEmailsList: 0,
    dndSuccessItems: 0,
    dndFailedItems: 0,
    ValidUserFile: true,
    ExcelFileError: "",
    ExcelEmails: [],
    ValidGPNList: [],
    emailError: "",
  };
  
  handleToggleMultiple = () => {
    this.setState({
      openMultiple: !this.state.openMultiple,
    });
  };

  ValidateDNDFile = () => {
    if (this.state.ValidGPNList.length === 0) {
      this.setState({
        ExcelFileError: "Upload a file with at least one valid user",
      });
      return false;
    }
    return true;
  };

  ValidateDoNotDisturb = () => {
    let valid = true;
    if (this.state.emailParam === "" || this.state.emailParam === undefined) {
      this.setState({ emailError: "This field is required" });
      valid = false;
    } else if (
      // eslint-disable-next-line
      /^([a-zA-Z0-9_\-\.]+)@(([a-zA-Z0-9_\-\.]+)\.)*(ey\.)(com|net)+$/.test(this.state.emailParam) === false
    ) {
      this.setState({ emailError: "The email format is invalid or is not an EY account" });
      valid = false;
    } else {
      this.setState({ emailError: "" });
    }

    return valid;
  };

  async onChangeImportExcel(e) {
    let file = e.target.files[0];
    if (file.size > process.env.REACT_API_MAX_FILE_SIZE) {
      MySwal.fire({
        icon: "error",
        title: "An error has occurred while uploading the file",
        text: "The file is too big",
        confirmButtonColor: "#FFE600",
        confirmButtonText: "<div style='color: black'>OK</div>",
      });
    } else {
      const filename = file.name;
      //Check if format is valid
      const extension = filename.substr(filename.lastIndexOf(".") + 1);
      if (
        extension !== "xlsx" &&
        extension !== "xls" &&
        extension !== "xlsm" &&
        extension !== "xlm"
      ) {
        await MySwal.fire({
          title: "Invalid file type",
          text: "The file must be a .xlsx, .xlsm, .xls, .xlm file",
          icon: "error",
        }).then(() => {
          this.setState({ ValidUserFile: false });
          return;
        });
      } else {
        this.setState({ ExcelFileError: "" });
        this.setState({ ValidUserFile: true });

        this.setState({
          loadingFile: true,
        });
        e.preventDefault();
        let valid = 0;
        let invalid = 0;
        let notDisturb = 0;
        let excelEmails = [];
        let validGpns = [];
        const data = new FormData();
        data.append("file", file);

        acquireToken().then((token) => {
          Axios
            .post(
              `${process.env.REACT_APP_API_URL}/CampaingAPI/ReadExcelEmails`,
              data,
              { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(async (res) => {
              if (res.data.code === 0) {
                excelEmails = res.data.items[0];

                this.setState({
                  ExcelEmails: excelEmails,
                })

                const chunkSize = 1000;
                for (var i = 0; i < excelEmails.length; i += chunkSize) {
                  let temparray = excelEmails.slice(i, i + chunkSize);

                  await acquireToken().then(async (token) => {
                    await Axios
                      .post(
                        `${process.env.REACT_APP_API_URL}/CampaingAPI/ValidateEmails`,
                        temparray,
                        { headers: { Authorization: `Bearer ${token}` } }
                      )
                      .then((res) => {
                        if (res.data.code === 0) {
                          let validationResults = res.data.items[0];
                          valid +=
                            validationResults.validGPNList === undefined
                              ? 0
                              : validationResults.validGPNList.length;
                          invalid +=
                            validationResults.invalidEmailsList === undefined
                              ? 0
                              : validationResults.invalidEmailsList.length;
                          notDisturb +=
                            validationResults.doNotDisturbEmailsList ===
                            undefined
                              ? 0
                              : validationResults.doNotDisturbEmailsList.length;

                          validGpns = validGpns.concat(
                            validationResults.validGPNList === undefined
                              ? []
                              : validationResults.validGPNList
                          );
                        } else {
                          throw new Error("Error");
                        }
                      });
                  });
                }
                this.setState({
                  ValidGPNList: validGpns,
                  validPeopleList: valid,
                  invalidEmailsList: invalid,
                  doNotDisturbEmailsList: notDisturb,
                  loadingFile: false,
                });
              } else {
                throw new Error("Error");
              }
            })
            .catch((error) => {
              if (error.toString().includes("status code 403")) {
                window.location.href = "/NoAuth";
              } else {
                MySwal.fire({
                  icon: "error",
                  title: "An error has occurred while uploading the file",
                  //text: error,
                  confirmButtonColor: "#FFE600",
                  confirmButtonText: "<div style='color: black'>OK</div>",
                });
              }
            });
        });
      }
    }
  }

  async handleSubmit() {
    //event.preventDefault();
    if (!this.ValidateDNDFile()) {
      MySwal.close();
      return;
    }
    this.setState({
      loadingFile: true,
    });
    /*
    let results = [];
    this.state.ExcelEmails.forEach((item) =>{
      let result = this.handleItem(item);
      //TODO: can't await above?
      console.log(result);
      results.push(result);
    });
    */
    Promise.all(
      this.state.ExcelEmails.map((item) => {
        return this.handleItem(item);
        //resolve(this.handleItem(item));
      })
    ).then((results)=>{
      console.log(results);
      let successItems = 0;
      let failedItems = 0;
      /*
      results.reduce(async (prev, next) => {
        await prev;
        if (next === 0) {
          successItems++;
        } else {
          failedItems++;
        }
      });
      */
      results.forEach((result) => {
        if (result === 0) {
          successItems++;
        } else {
          failedItems++;
        }
      });
      this.setState({
        loadingFile: false,
        openMultiple: false,
        dndSuccessItems: successItems,
        dndFailedItems: failedItems,
      });
      MySwal.fire({
        icon: "success",
        //title: `${this.state.dndSuccessItems} user(s) added successfully, ${this.state.dndFailedItems} failed.`,
        title: `Users are being added now. Refresh the page to see the changes.`,
        confirmButtonColor: "#FFE600",
        confirmButtonText: "<div style='color: black'>OK</div>",
      })/*.then(() => {
        window.location.reload();
      })*/;
    });
  };

  handleItem(item) {
    this.setState({
      emailParam: item,
    });
    if (this.ValidateDoNotDisturb()) {
      acquireToken().then((token) => {
        //let url = `${process.env.REACT_APP_API_URL}/UserAPI/GetUserGPNPerEmail/${item}`;
        let url = `${process.env.REACT_APP_API_URL}/UserAPI/GetUserGPNPerEmail`;
        this.setState({ loadingFile: true });
  
        //Axios.get(url, {
        Axios.post(url, {
          email: item
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then((res) => {
          if (res.data.code === 0) {
            if (res.data.items.length === 0) {
              //throw Error();
              console.log(res.data.code);
            }
            let emailId = res.data.items[0].userId;
            this.setState((prevState) => ({
              js: {
                ...prevState.js,
                excludedEmail: {
                  ...prevState.js.excludedEmail,
                  excludedEmailId: emailId,
                  excludedEmailCreateDate: new Date(),
                  excludedEmailLastUpdateDate: new Date(),
                },
              },
            }));
            acquireToken().then((token) => {
              const url = `${process.env.REACT_APP_API_URL}/ExcludedEmailAPI/AddExcludedEmail`;
              Axios.post(url, {
                excludedEmail: {
                  excludedEmailStatus: true,
                  excludedEmailUserModifiedId: this.context.userId,
                  excludedEmailId: emailId,
                  excludedEmailCreateDate: new Date(),
                  excludedEmailLastUpdateDate: new Date(),
                },
                user: this.context,
              }, {
                headers: {
                  "content-type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }).then((res) => {
                //If user exists, update instead
                if (res.data.code === 2601 || res.data.code === 2627) {
                  acquireToken().then((token) => {
                    let url = `${process.env.REACT_APP_API_URL}/ExcludedEmailAPI/UpdateExcludedEmail`;
                    this.setState({
                      loadingFile: true
                    });
                    Axios.post(url, {
                      excludedEmail: {
                        excludedEmailStatus: true,
                        excludedEmailUserModifiedId: this.context.userId,
                        excludedEmailId: emailId,
                        excludedEmailCreateDate: new Date(),
                        excludedEmailLastUpdateDate: new Date(),
                      },
                      user: this.context,
                    }, {
                      headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                    }).then((res) => {
                      console.log(res.data.code);
                      return res.data.code;
                    });
                  });
                } else {
                  console.log(res.data.code);
                  return res.data.code;
                }
              }).catch((error) => {
                return 400;
              });
            });
          } else {
            return 400;
          }
        }).catch((error) => {
          return 403;
        });
      });
    }
  };

  render() {
    const {
      openMultiple,
      loadingFile,
      validPeopleList,
      invalidEmailsList,
      doNotDisturbEmailsList,
    } = this.state;

    return (
      <Fragment>
        <div style={{ paddingTop: "0.6rem" }}>
          <Button onClick={this.handleToggleMultiple}>Add Multiple Email Accounts</Button>
        </div>

        <Dialog open={openMultiple} onClose={this.handleToggleMultiple} style={{ zIndex: 100 }}>
          <DialogTitle id="form-dialog-title">Add Email Accounts</DialogTitle>
          <DialogContent>
            <DialogContentText>
              The file must contain a column of emails
            </DialogContentText>
            <form
              onSubmit={() => {}}
            >
              <Grid container spacing={2}>
                <Grid item>
                  <div onSubmit={this.onFormSubmit}>
                    <h3>Upload a file</h3>
                    <input
                      type="file"
                      name="file"
                      onChange={(e) => this.onChangeImportExcel(e)}
                    />
                    <div style={{ color: "red" }}>
                      {this.state.ExcelFileError}
                    </div>
                  </div>
                </Grid>
                <Grid item>
                  {loadingFile ? (
                    <div>
                      <Alert color="primary" fade={false}>
                        This operation might take a moment.
                      </Alert>
                      <Spinner />
                    </div>
                  ) : (
                    <div>
                      <label>
                        Total emails:{" "}
                        {validPeopleList +
                          invalidEmailsList +
                          doNotDisturbEmailsList}
                      </label>
                      <br />
                      <label>Valid Emails: {validPeopleList}</label>
                      <br />
                      <label>Invalid Emails: {invalidEmailsList}</label>
                      <br />
                      <label>
                        People in Do Not Disturb List:{" "}
                        {doNotDisturbEmailsList}
                      </label>
                    </div>
                  )}
                </Grid>
              </Grid>
              <Button
                color="primary"
                onClick={() => {
                  MySwal.fire({
                    title:
                      "Are you sure you want to add these users to the DND list?",
                    text: "",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#FFE600",
                    fontSize: "1.5rem",
                    cancelButtonColor: "#2E2E38",
                    confirmButtonText:
                      "<div style='color: black'>Continue</div>",
                    showLoaderOnConfirm: true,
                  }).then((result) => {
                    if (result.value) {
                      MySwal.fire({
                        title: "Adding users to DND list",
                        allowOutsideClick: false,
                        onBeforeOpen: () => {
                          Swal.showLoading();
                        },
                      });
                      this.handleSubmit();
                    }
                  });
                }}
              >
                Add to List
              </Button>
            </form>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DoNotDisturbAddMultipleForm.contextType = LoggedUserContext;
